import { render, staticRenderFns } from "./EventAndTips.vue?vue&type=template&id=d345e438&scoped=true&"
import script from "./EventAndTips.vue?vue&type=script&lang=js&"
export * from "./EventAndTips.vue?vue&type=script&lang=js&"
import style0 from "./EventAndTips.vue?vue&type=style&index=0&id=d345e438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d345e438",
  null
  
)

export default component.exports